import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import TimelineFilters from "../components/timeline/TimelineFilters";
import TimelineEventsList from "../components/timeline/TimelineEventsList";
import TimelineFilterModal from "../components/timeline/TimelineFilterModal";
import TimelineHeader from "../components/timeline/TimelineHeader";
import { useTimelineFilters } from "../hooks/useTimelineFilters";
import { useTimelineData } from "../hooks/useTimelineData";
import '../assets/timeline.css';

const DistributorEventsTimeline = () => {
    const { uuid } = useParams();
    const [showFilterModal, setShowFilterModal] = useState(false);
    
    const {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedManager,
        setSelectedManager,
        selectedPurpose,
        setSelectedPurpose,
        appliedFilters,
        applyFilters,
        clearFilters,
        removeFilter
    } = useTimelineFilters();

    const {
        entityName,
        metadata,
        events,
        filteredEvents,
        managerOptions,
        purposeTypes
    } = useTimelineData(uuid, 'distributor', appliedFilters);

    const purposeOptions = Object.keys(purposeTypes).map(key => ({
        label: purposeTypes[key].label,
        value: key
    }));

    const handleApplyFilters = () => {
        applyFilters();
        setShowFilterModal(false);
    };

    const handleClearFilters = () => {
        clearFilters();
        setShowFilterModal(false);
    };

    return (
        <div id="wrapper">
            <Sidebar act="distributors" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="Distributor Events Timeline" breadcrumbItems={['Sales App', { label: 'Distributors', path: '/distributors' }, 'Timeline']} />
                    
                    <div className="container-fluid main-container">
                        <TimelineFilters
                            appliedFilters={appliedFilters}
                            managerOptions={managerOptions}
                            purposeTypes={purposeTypes}
                            removeFilter={removeFilter}
                            clearFilters={handleClearFilters}
                        />

                        {/* Timeline Section */}
                        <div className="card main-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <TimelineHeader
                                        entityName={entityName}
                                        metadata={metadata}
                                        entityType="distributor"
                                    />
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="text-muted">
                                            Showing {filteredEvents.length} of {events.length} events
                                        </span>
                                        <div className="filter-wrapper">
                                            <button 
                                                className="btn btn-filter btn-sm" 
                                                onClick={() => setShowFilterModal(true)}
                                                title="Filter Events"
                                            >
                                                <i className="mdi mdi-filter-outline"></i>
                                            </button>
                                            <TimelineFilterModal
                                                show={showFilterModal}
                                                onClose={() => setShowFilterModal(false)}
                                                onApply={handleApplyFilters}
                                                onReset={handleClearFilters}
                                                startDate={startDate}
                                                setStartDate={setStartDate}
                                                endDate={endDate}
                                                setEndDate={setEndDate}
                                                managerOptions={managerOptions}
                                                selectedManager={selectedManager}
                                                setSelectedManager={setSelectedManager}
                                                purposeOptions={purposeOptions}
                                                selectedPurpose={selectedPurpose}
                                                setSelectedPurpose={setSelectedPurpose}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="timeline-container">
                                    <TimelineEventsList
                                        events={filteredEvents}
                                        purposeTypes={purposeTypes}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default DistributorEventsTimeline;
